import { RhcField } from 'features/generator/components/RhcField'
import { useSetAtom } from 'jotai'
import { useTranslations } from 'next-intl'
import { useFormContext } from 'react-hook-form'

import { TVideo, TVideoFields } from '../VideoFormModel'
import { videoListAtom } from './VideoDetailsFields'

export const VideoTitleField = ({
	index,
	videoList,
}: {
	index: number
	videoList: TVideo[]
}) => {
	const t = useTranslations()
	const form = useFormContext<TVideoFields>()

	const setVideoList = useSetAtom(videoListAtom)

	const setValue = (value?: string) => {
		if (value !== undefined) {
			setVideoList((prev) => {
				const newValue = [...prev]
				newValue[index]!.video.name = value
				return newValue
			})
		}
	}

	return (
		<RhcField
			type="text"
			form={form}
			required
			path={`videos.${index}.video.name`}
			error={form.formState.errors.videos?.[index]?.video?.name?.message}
			value={videoList[index]!.video.name}
			setValue={setValue}
			fieldName="video_title"
			fieldGroup="videos"
			label={t(
				'generator__content_form_section__videos_information__headline__label',
			)}
			placeholder={t(
				'generator__content_form_section__videos_information__headline__placeholder',
			)}
			className="grow tablet:w-full"
		/>
	)
}
